/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { SecureRoute, ImplicitCallback, withAuth } from "@okta/okta-react";
import Home from "../Home/Home";
import Navbar from "../Navigation/Navbar";
import Footer from "../Footer/Footer";
import SASReport from "../SASReport/SASReport";
import DrillDownReport from "../SASReport/Report/DrillDownReport";
import TASReport from "../TASReport/TASReport";
import TASLAReport from "../TASReport/TASLAReport";
import Timer from "../Common/controls/Timer/Timer";
import Logout from "../Common/controls/Logout/Logout";
import { checkAuthentication } from "../../helpers";
import { connect } from "react-redux";
import { storeCredential } from "./actions";
import PageNotFound from "../PageNotFound";
import "./App.css";

class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: null,
      username: null,
      token: null,
      showNavBar: true
    };
    this.checkAuthentication = checkAuthentication.bind(this);
  }

  async componentDidMount() {
    this.checkAuthentication();
  }

  async componentUpdateMount() {
    this.checkAuthentication();
  }

  hideNavigationBar = () => {
    this.setState({ showNavBar: false });
  };

  render() {
    return (
      <React.Fragment>
        <Navbar {...this.state} {...this.props.auth} />
        <Timer {...this.props} />
        <div className="contentbgcolor">
          <Switch>
            <SecureRoute exact path="/" component={Home} />
            <SecureRoute exact path="/SASReport" component={SASReport} />
            <SecureRoute
              exact
              path="/drillDownReport"
              component={DrillDownReport}
            />
            <SecureRoute exact path="/TASLAReport" component={TASLAReport} />
            <SecureRoute exact path="/TASReport" component={TASReport} />
            <Route
              path="/implicit/callback"
              exact
              component={ImplicitCallback}
            />
            <Route
              exact
              path="/Logout"
              render={props => (
                <Logout {...this.state} hideNavBar={this.hideNavigationBar} />
              )}
            />
            <Route component={PageNotFound} />
          </Switch>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withAuth(
  withRouter(
    connect(
      null,
      { storeCredential }
    )(App)
  )
);
